(function () {
  window.isolaEmbroideryVersion = "2026-09-15.1";

  function setFieldState(fields, enabled) {
    fields.forEach(function (field) {
      if (field.hasAttribute("data-embroidery-enabled")) return;
      field.disabled = !enabled;
    });
  }

  function setupEmbroidery(block) {
    if (block.dataset.isolaEmbroideryReady === "true") return;

    var form = block.closest("form");
    var enabledInput = block.querySelector("[data-embroidery-enabled]");
    var fieldsWrap = block.querySelector("[data-embroidery-fields]");
    var layoutInput = block.querySelector("[data-embroidery-layout]");
    var textInput = block.querySelector("[data-embroidery-text]");
    var line2Field = block.querySelector("[data-embroidery-line2-field]");
    var line2Input = block.querySelector("[data-embroidery-line2]");
    var helpText = block.querySelector("[data-embroidery-help]");
    var typeInput = block.querySelector("[data-embroidery-type]");
    var fontInput = block.querySelector("[data-embroidery-font]");
    var sizeInput = block.querySelector("[data-embroidery-size]");
    var positionInput = block.querySelector("[data-embroidery-position]");
    var letterCaseInput = block.querySelector("[data-embroidery-letter-case]");
    var sampleWrap = block.querySelector("[data-embroidery-sample]");
    var sampleToggle = block.querySelector("[data-embroidery-sample-toggle]");
    var samplePanel = block.querySelector("[data-embroidery-sample-panel]");
    var sampleImage = block.querySelector("[data-embroidery-sample-image]");
    var sampleModalImage = block.querySelector("[data-embroidery-sample-modal-image]");
    var sampleClose = block.querySelector("[data-embroidery-sample-close]");
    var sampleTitle = block.querySelector("[data-embroidery-sample-title]");
    var sampleLabel = block.querySelector("[data-embroidery-sample-label]");
    var textCount = block.querySelector("[data-embroidery-text-count]");
    var line2Count = block.querySelector("[data-embroidery-line2-count]");
    var previewSurface = block.querySelector("[data-embroidery-preview-surface]");
    var previewLine1 = block.querySelector("[data-embroidery-preview-line1]");
    var previewLine2 = block.querySelector("[data-embroidery-preview-line2]");
    var previewFont = block.querySelector("[data-embroidery-preview-font]");
    var previewPosition = block.querySelector("[data-embroidery-preview-position]");
    var previewSize = block.querySelector("[data-embroidery-preview-size]");
    var previewColor = block.querySelector("[data-embroidery-preview-color]");
    var propertyFields = Array.prototype.slice.call(block.querySelectorAll("input, select, textarea"));

    if (!enabledInput || !fieldsWrap || !layoutInput || !textInput || !typeInput || !fontInput || !sizeInput || !positionInput || !letterCaseInput) return;

    block.dataset.isolaEmbroideryReady = "true";

    function getPlaceholderByType(type) {
      if (type === "Nome") return "Ex: Luiza";
      if (type === "Frase curta") return "Ex: Bons sonhos";
      if (type === "Uma letra") return "Ex: A";
      if (type === "Duas letras") return "Ex: AB";
      return "Ex: ABC";
    }

    function getMaxLengthBySize() {
      if (!sizeInput) return 10;
      if (sizeInput.value.indexOf("7,0 cm") === 0) return 6;
      if (sizeInput.value.indexOf("5,0 cm") === 0) return 8;
      return 10;
    }

    function getMaxLengthByType(type) {
      if (type === "Nome") return 16;
      if (type === "Frase curta") return 24;
      if (type === "Uma letra") return 1;
      if (type === "Duas letras") return 2;
      return 3;
    }

    function isLetterType(type) {
      return type === "Tres letras" || type === "Duas letras" || type === "Uma letra";
    }

    function updateSampleImage() {
      if (!sampleWrap || !sampleToggle || !samplePanel || !sampleImage) return;

      var selectedOption = fontInput.options[fontInput.selectedIndex];
      var defaultSampleUrl = sampleWrap.getAttribute("data-default-sample-image") || "";
      var sampleUrl = selectedOption ? selectedOption.getAttribute("data-sample-image") : "";
      sampleUrl = sampleUrl || defaultSampleUrl;

      if (!sampleUrl) {
        sampleWrap.hidden = true;
        samplePanel.hidden = true;
        sampleToggle.setAttribute("aria-expanded", "false");
        sampleImage.removeAttribute("src");
        sampleImage.alt = "";
        return;
      }

      sampleWrap.hidden = false;
      sampleImage.src = sampleUrl;
      sampleImage.alt = "Exemplo real da fonte " + fontInput.value + " em bordado";
      sampleToggle.setAttribute("aria-label", "Ampliar exemplo real da " + fontInput.value);
      if (sampleModalImage) {
        sampleModalImage.src = sampleUrl;
        sampleModalImage.alt = sampleImage.alt;
      }
      if (sampleTitle) {
        sampleTitle.textContent = "Exemplo real — " + fontInput.value;
      }
      if (sampleLabel) {
        sampleLabel.textContent = "Exemplo real — " + fontInput.value;
      }
    }

    function updateEntryPreview(text, line2, layout) {
      var selectedSize = sizeInput.options[sizeInput.selectedIndex];
      var selectedColor = block.querySelector("[data-embroidery-color]:checked");
      var selectedColorLabel = selectedColor ? selectedColor.closest("label").querySelector("span") : null;

      if (previewSurface) {
        previewSurface.dataset.position = positionInput.value;
        if (selectedColor) {
          previewSurface.style.setProperty("--preview-color", selectedColor.dataset.embroideryColor || "#315f79");
        }
      }
      if (previewLine1) {
        previewLine1.textContent = text.trim() || "Digite o texto";
      }
      if (previewLine2) {
        previewLine2.hidden = layout !== "Duas linhas";
        previewLine2.textContent = line2.trim() || "Digite a segunda linha";
      }
      if (previewFont) previewFont.textContent = fontInput.value || "Fonte não selecionada";
      if (previewPosition) previewPosition.textContent = positionInput.value;
      if (previewSize) previewSize.textContent = selectedSize ? selectedSize.textContent.trim() : sizeInput.value;
      if (previewColor) {
        previewColor.textContent = selectedColorLabel ? selectedColorLabel.textContent.trim() : "Cor não selecionada";
      }
    }

    function openSamplePanel() {
      if (!sampleToggle || !samplePanel) return;
      document.body.appendChild(samplePanel);
      samplePanel.hidden = false;
      document.documentElement.classList.add("isola-embroidery-modal-open");
      sampleToggle.setAttribute("aria-expanded", "true");
    }

    function closeSamplePanel() {
      if (!sampleToggle || !samplePanel) return;
      samplePanel.hidden = true;
      if (sampleWrap) sampleWrap.appendChild(samplePanel);
      document.documentElement.classList.remove("isola-embroidery-modal-open");
      sampleToggle.setAttribute("aria-expanded", "false");
    }

    function updateEmbroideryFields() {
      var layout = layoutInput.value;
      var type = typeInput.value;
      var maxLength = Math.min(getMaxLengthByType(type), getMaxLengthBySize());
      var text = textInput.value;
      var line2 = line2Input ? line2Input.value : "";
      var useUppercase = letterCaseInput.value === "Maiusculas";

      textInput.maxLength = maxLength;
      textInput.placeholder = getPlaceholderByType(type);

      if (line2Field) {
        line2Field.hidden = layout !== "Duas linhas";
      }

      if (line2Input) {
        line2Input.disabled = !enabledInput.checked || layout !== "Duas linhas";
        line2Input.required = enabledInput.checked && layout === "Duas linhas";
        line2Input.maxLength = maxLength;
      }

      if (helpText) {
        helpText.textContent = isLetterType(type)
          ? "Para monograma, informe as letras na ordem desejada."
          : "O tamanho escolhido permite ate " + getMaxLengthBySize() + " letras.";
      }

      if (text.length > maxLength) {
        text = text.slice(0, maxLength);
        textInput.value = text;
      }

      if (isLetterType(type)) {
        text = text.replace(/[^A-Za-zÀ-ÿ]/g, "").slice(0, maxLength);
        line2 = line2.replace(/[^A-Za-zÀ-ÿ]/g, "").slice(0, maxLength);
      } else {
        line2 = line2.slice(0, maxLength);
      }

      text = useUppercase ? text.toLocaleUpperCase("pt-BR") : text.toLocaleLowerCase("pt-BR");
      line2 = useUppercase ? line2.toLocaleUpperCase("pt-BR") : line2.toLocaleLowerCase("pt-BR");
      textInput.value = text;
      if (line2Input) line2Input.value = line2;
      if (textCount) textCount.textContent = text.length + "/" + maxLength;
      if (line2Count) line2Count.textContent = line2.length + "/" + maxLength;
      updateSampleImage();
      updateEntryPreview(text, line2, layout);
    }

    function updateEnabledState() {
      var enabled = enabledInput.checked;
      fieldsWrap.hidden = !enabled;
      setFieldState(propertyFields, enabled);
      enabledInput.disabled = false;
      updateEmbroideryFields();
    }

    enabledInput.addEventListener("change", updateEnabledState);
    block.addEventListener("input", updateEmbroideryFields);
    block.addEventListener("change", updateEmbroideryFields);
    if (sampleToggle && samplePanel) {
      sampleToggle.addEventListener("click", function () {
        if (samplePanel.hidden) {
          openSamplePanel();
        } else {
          closeSamplePanel();
        }
      });
    }
    if (sampleClose) {
      sampleClose.addEventListener("click", closeSamplePanel);
    }
    if (samplePanel) {
      samplePanel.addEventListener("click", function (event) {
        if (event.target === samplePanel) closeSamplePanel();
      });
    }
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && samplePanel && !samplePanel.hidden) {
        closeSamplePanel();
      }
    });

    updateEnabledState();
  }

  function initEmbroidery(context) {
    var root = context || document;

    root.querySelectorAll("[data-isola-embroidery]").forEach(setupEmbroidery);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initEmbroidery(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initEmbroidery(event.target);
  });

  if (document.readyState !== "loading") {
    document.querySelectorAll("[data-isola-embroidery]").forEach(setupEmbroidery);
  }
})();
